/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateFormulaContentDto } from './UpdateFormulaContentDto';
import {
    UpdateFormulaContentDtoFromJSON,
    UpdateFormulaContentDtoFromJSONTyped,
    UpdateFormulaContentDtoToJSON,
    UpdateFormulaContentDtoToJSONTyped,
} from './UpdateFormulaContentDto';

/**
 * 
 * @export
 * @interface UpdateFormulaRequestDto
 */
export interface UpdateFormulaRequestDto {
    /**
     * Contents of the formula - array of materials with weights
     * @type {Array<UpdateFormulaContentDto>}
     * @memberof UpdateFormulaRequestDto
     */
    contents: Array<UpdateFormulaContentDto>;
    /**
     * Supply of daily servings (number of days). If not provided, the existing formula supply will be used.
     * @type {number}
     * @memberof UpdateFormulaRequestDto
     */
    supply?: number;
    /**
     * Optional notes for the formula
     * @type {string}
     * @memberof UpdateFormulaRequestDto
     */
    notes?: string;
}

/**
 * Check if a given object implements the UpdateFormulaRequestDto interface.
 */
export function instanceOfUpdateFormulaRequestDto(value: object): value is UpdateFormulaRequestDto {
    if (!('contents' in value) || value['contents'] === undefined) return false;
    return true;
}

export function UpdateFormulaRequestDtoFromJSON(json: any): UpdateFormulaRequestDto {
    return UpdateFormulaRequestDtoFromJSONTyped(json, false);
}

export function UpdateFormulaRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFormulaRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contents': ((json['contents'] as Array<any>).map(UpdateFormulaContentDtoFromJSON)),
        'supply': json['supply'] == null ? undefined : json['supply'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateFormulaRequestDtoToJSON(json: any): UpdateFormulaRequestDto {
    return UpdateFormulaRequestDtoToJSONTyped(json, false);
}

export function UpdateFormulaRequestDtoToJSONTyped(value?: UpdateFormulaRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contents': ((value['contents'] as Array<any>).map(UpdateFormulaContentDtoToJSON)),
        'supply': value['supply'],
        'notes': value['notes'],
    };
}

